import React from 'react';
import BirthdayNotifSvg from './birthday-notificationV2.svg';
import CalendarNotifSvg from './calendar-notificationV2.svg';
import CalendarXSvg from './calendar-xmark-regular.svg';
import CheckmarkCircleGreenSvg from './checkmark-circle-green.svg';
import DocumentNotifSvg from './documentNotification.svg';
import EmptyAvatar from './EmptyAvatar.svg';
import ErrorIcon from './error.svg';
import FigmaColouredSvg from './figmaColoured.svg';
import GreenCheckmark from './green-checkmark.svg';
import PTOApproveNotifSvg from './PTOApproveNotificationV2.svg';
import './icons.scss';
import InfoIconSVG from './information.svg';
import LockIcon from './lock.svg';
import RedTrashcan from './red-trashcan.svg';
import TelescopeIcon from './telescope.svg';
import TimesheetSuccessSvg from './timesheetSuccess.svg';
import TimesheetWarningSvg from './timesheetWarning.svg';
import UploadIcon from './upload.svg';
import WarningYellowSvg from './warning-yellow.svg';
import WarningOrangeSvg from './warningOrange.svg';
import WarningRedSvg from './warningRed.svg';

// KG LOGO
const kgLogo = (
  <svg
    width='20px'
    height='20px'
    viewBox='0 0 20 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='KG-Portal-Original-Icons' transform='translate(-69.000000, -192.000000)' fill='#fff'>
        <g id='kg-logo' transform='translate(69.000000, 192.000000)'>
          <path
            style={{ fillRule: 'evenodd', fill: '#fff' }}
            d='M7.397,0 L18.389,0 L12.893,5.489 L7.397,0 Z M19.997,19.997 L14.731,19.997 L7.365,12.631 L0.002,5.267 L0.002,0 L9.998,9.997 L19.997,19.997 Z M7.33,19.997 L0.002,19.997 L0.002,12.679 L3.666,16.338 L7.33,19.997 Z'
            id='Shape'></path>
        </g>
      </g>
    </g>
  </svg>
);
const kgLogoDev = (
  <svg
    width='20px'
    height='20px'
    viewBox='0 0 20 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='KG-Portal-Original-Icons' transform='translate(-69.000000, -192.000000)' fill='#FFCCCB'>
        <g id='kg-logo' transform='translate(69.000000, 192.000000)'>
          <path
            style={{ fillRule: 'evenodd', fill: '#FFCCCB' }}
            d='M7.397,0 L18.389,0 L12.893,5.489 L7.397,0 Z M19.997,19.997 L14.731,19.997 L7.365,12.631 L0.002,5.267 L0.002,0 L9.998,9.997 L19.997,19.997 Z M7.33,19.997 L0.002,19.997 L0.002,12.679 L3.666,16.338 L7.33,19.997 Z'
            id='Shape'></path>
        </g>
      </g>
    </g>
  </svg>
);
const kgLogoStage = (
  <svg
    width='20px'
    height='20px'
    viewBox='0 0 20 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='KG-Portal-Original-Icons' transform='translate(-69.000000, -192.000000)' fill='#FFDBBB'>
        <g id='kg-logo' transform='translate(69.000000, 192.000000)'>
          <path
            style={{ fillRule: 'evenodd', fill: '#FFDBBB' }}
            d='M7.397,0 L18.389,0 L12.893,5.489 L7.397,0 Z M19.997,19.997 L14.731,19.997 L7.365,12.631 L0.002,5.267 L0.002,0 L9.998,9.997 L19.997,19.997 Z M7.33,19.997 L0.002,19.997 L0.002,12.679 L3.666,16.338 L7.33,19.997 Z'
            id='Shape'></path>
        </g>
      </g>
    </g>
  </svg>
);
const kgLogoBlack = (
  <svg
    width='12px'
    height='12px'
    viewBox='0 0 20 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='KG-Portal-Original-Icons-b' transform='translate(-69.000000, -192.000000)' fill='#fff'>
        <g id='kg-logo-b' transform='translate(69.000000, 192.000000)'>
          <path
            style={{ fillRule: 'evenodd', fill: '#000' }}
            d='M7.397,0 L18.389,0 L12.893,5.489 L7.397,0 Z M19.997,19.997 L14.731,19.997 L7.365,12.631 L0.002,5.267 L0.002,0 L9.998,9.997 L19.997,19.997 Z M7.33,19.997 L0.002,19.997 L0.002,12.679 L3.666,16.338 L7.33,19.997 Z'
            id='Shape'></path>
        </g>
      </g>
    </g>
  </svg>
);

// ESSENTIALS
const Abacus = <i className='far fa-abacus fa-fw'></i>;
const Admin = <i className='fa-regular fa-gear'></i>;
const AppShop = <i className='far fa-shopping-bag fa-fw'></i>;
const ArrowDown = <i className='far fa-long-arrow-down fa-fw'></i>;
const ArrowLeft = <i className='far fa-long-arrow-left fa-fw'></i>;
const ArrowRight = <i className='far fa-long-arrow-right'></i>;
const ArrowUp = <i className='far fa-long-arrow-up fa-fw'></i>;
const BirthdayCake = <i className='far fa-birthday-cake fa-fw'></i>;
const Building = <i className='far fa-building fa-fw'></i>;
const Bullseye = <i className='far fa-bullseye fa-fw'></i>;
const Calendar = <i className='far fa-calendar-alt fa-fw'></i>;
const Car = <i className='far fa-car-side fa-fw'></i>;
const CheckCircle = <i className='fas fa-check-circle fa-fw'></i>;
const Checkmark = <i className='far fa-check fa-fw'></i>;
const ChevronDown = <i className='fas fa-chevron-down fa-fw'></i>;
const ChevronLeft = <i className='fas fa-chevron-left fa-fw'></i>;
const ChevronRight = <i className='fas fa-chevron-right fa-fw'></i>;
const ChevronUp = <i className='fas fa-chevron-up fa-fw'></i>;
const ChevronsDown = <i className='fa-light fa-chevrons-down'></i>;
const ChevronsUp = <i className='fa-solid fa-chevrons-up'></i>;
const Clipboard = <i className='far fa-clipboard-list fa-fw'></i>;
const Clock = <i className='far fa-clock fa-fw'></i>;
const ClosedCircle = <i className='far fa-times-circle fa-fw'></i>;
const Comment = <i className='far fa-comment fa-fw'></i>;
const Copy = <i className='far fa-copy fa-fw'></i>;
const Crosshairs = <i className='far fa-crosshairs fa-fw'></i>;
const Delete = <i className='far fa-trash-alt fa-fw'></i>;
const Directory = <i className='far fa-address-book fa-fw'></i>;
const Download = <i className='far fa-cloud-download'></i>;
const Edit = <i className='far fa-pencil fa-fw'></i>;
const Ellipsis = <i className='far fa-ellipsis-v fa-fw'></i>;
const Email = <i className='fa-solid fa-envelope'></i>;
const Exit = <i className='far fa-times fa-fw'></i>;
const Expand = <i className='far fa-arrows-h fa-fw'></i>;
const External = <i className='fa-regular fa-arrow-up-right-from-square'></i>;
const FastForward = <i className='far fa-fast-forward fa-fw'></i>;
const ForwardStep = <i className='far fa-forward-step fa-fw'></i>;
const FigmaColoured = <img src={FigmaColouredSvg}></img>; // not available on font awesome
const FigmaNoColour = <i className='fab fa-figma fa-fw'></i>;
const Filter = <i className='fas fa-filter fa-fw'></i>;
const Globe = <i className='far fa-globe fa-fw'></i>;
const GradCap = <i className='far fa-graduation-cap fa-fw'></i>;
const GreenCheckmarkCircle = <img alt='Green Checkmark Icon' src={GreenCheckmark}></img>;
const Handbook = <i className='far fa-book-open fa-fw'></i>;
const Home = <i className='far fa-home fa-fw'></i>;
const HotPepper = <i className='fa-regular fa-pepper-hot'></i>;
const IndeterminateCheckbox = <i className='far fa-minus-square fa-fw'></i>;
const Info = <i className='far fa-info-circle fa-fw'></i>;
const Inventory = <i className='far fa-inventory fa-fw'></i>;
const ITSupport = <i className='far fa-mouse fa-fw'></i>;
const Key = <i className='far fa-key fa-fw'></i>;
const Knowledge = <i className='far fa-chess-knight fa-fw'></i>;
const Learn = <i className='far fa-laptop fa-fw'></i>;
const Link = <i className='far fa-link fa-fw'></i>;
const List = <i className='far fa-list fa-fw'></i>;
const LocationPin = <i className='far fa-map-marker-alt fa-fw'></i>;
const MagicWand = <i className='fa-regular fa-wand-magic-sparkles'></i>;
const Mail = <i className='far fa-at fa-fw'></i>;
const Menu = <i className='far fa-bars fa-fw'></i>;
const Minus = <i className='far fa-minus fa-fw'></i>;
const MousePointer = <i className='far fa-mouse-pointer fa-fw'></i>;
const Move = <i className='far fa-arrows fa-fw'></i>;
const Party = <i className='fa-regular fa-party-horn'></i>;
const Phone = <i className='far fa-phone fa-fw'></i>;
const Planner = <i className='far fa-pencil-ruler fa-fw'></i>;
const Planner2 = <i className='far fa-browser fa-fw'></i>;
const Play = <i className='far fa-play-circle fa-fw'></i>;
const Plus = <i className='far fa-plus fa-fw'></i>;
const Pointer = <i className='far fa-hand-pointer fa-fw'></i>; // Could not find matching pointer (current has lines on hand)
const Polaris = <i className='fa-sharp fa-solid fa-star-christmas'></i>;
const PowerHour = <i className='far fa-bolt fa-fw'></i>;
const Pulse = <i className='far fa-signal-alt fa-fw'></i>;
const RedTrashIcon = <img alt='Red Trashcan Icon' src={RedTrashcan}></img>;
const Rocket = <i className='far fa-rocket-launch fa-fw'></i>;
const Salesforce = <i className='fab fa-salesforce'></i>;
const Save = <i className='far fa-save fa-fw'></i>;
const Sandwich = <i className='fa-regular fa-burger-soda'></i>;
const Search = <i className='far fa-search fa-fw'></i>;
const SelectedCheckbox = <i className='far fa-check-square fa-fw'></i>;
const Settings = <i className='far fa-cog fa-fw'></i>;
const SingleUser = <i className='far fa-user fa-fw'></i>;
const SmallLock = <i className='fa-sharp fa-regular fa-lock'></i>;
const Sync = <i className='far fa-sync fa-fw'></i>;
const Team = <i className='far fa-users fa-fw'></i>;
const UnselectedCheckbox = <i className='far fa-square fa-fw'></i>;
const Upload2 = <i className='far fa-file-upload'></i>;
const UserClock = <i className='far fa-user-clock fa-fw'></i>;
const Vault = <i className='far fa-folders fa-fw'></i>;
const Warning = <i className='fas fa-exclamation-triangle fa-fw'></i>; // Could not find matching warning (current has rounded corners)
const WarningCircle = <i className='far fa-exclamation-circle fa-fw'></i>;

// Action Button Icons
const ActionEdit = <i className='far fa-pencil fa-fw'></i>;
const ActionDelete = <i className='far fa-trash-alt fa-fw'></i>;
const ActionComplete = <i className='far fa-check fa-fw'></i>;
const ActionView = <i className='far fa-eye fa-fw'></i>;
const ActionAdd = <i className='far fa-plus fa-fw'></i>;
const ActionSave = <i className='far fa-save fa-fw'></i>;
const ActionCancel = <i className='far fa-times fa-fw'></i>;
const ActionRefresh = <i className='far fa-sync fa-fw'></i>;
const ActionDownload = <i className='far fa-download fa-fw'></i>;
const ActionUpload = <i className='far fa-upload fa-fw'></i>;
const ActionShare = <i className='far fa-share-alt fa-fw'></i>;
const ActionPrint = <i className='far fa-print fa-fw'></i>;
const ActionExport = <i className='far fa-file-export fa-fw'></i>;
const ActionImport = <i className='far fa-file-import fa-fw'></i>;

// Archive Icon
const Archive = <i className='far fa-archive fa-fw'></i>;

// Radio Button States
const UnselectedRadio = <i className='far fa-circle fa-fw'></i>;
const SelectedRadio = <i className='far fa-dot-circle fa-fw'></i>;

const Close = (
  <div className='fa-stack small close'>
    <i className='fas fa-circle fa-stack-1x fa-inverse'></i>
    <i className='far fa-times-circle black fa-stack-1x'></i>
  </div>
);

// MESSAGING
const WarningNotifOrange = <img className='bg-orange' alt='warning' src={WarningOrangeSvg}></img>;
const WarningNotifRed = <img className='bg-red' alt='warning' src={WarningRedSvg}></img>;
const ConfirmNotif = <i className='fad fa-check-circle fa-fw'></i>;
const TimesheetWarningNotif = <img alt='timesheet warning notification' src={TimesheetWarningSvg}></img>;
const TimesheetSuccessNotif = <img alt='timesheet success notification' src={TimesheetSuccessSvg}></img>;
const Information = <img alt='i' src={InfoIconSVG}></img>;
const Slack = <i className='fab fa-slack fa-fw'></i>;

// Messaging with soft-blue circle background
const BirthdayNotif = <img src={BirthdayNotifSvg} alt='Birthday Icon'></img>;
const CalendarNotif = <img src={CalendarNotifSvg} alt='Calendar Icon'></img>;
const DocumentNotif = <img src={DocumentNotifSvg} alt='Document Icon'></img>;
const PTOApproveNotif = <img src={PTOApproveNotifSvg} alt='PTO Approval Icon'></img>;
const EmptyAvatarIcon = <img src={EmptyAvatar} alt='Empty Avatar Icon'></img>;

// Error Page Icons
const ErrorIcons2 = <img src={ErrorIcon} alt='Error Icon'></img>;
const Telelecope = <img src={TelescopeIcon} alt='Telelecope Icon'></img>;
const Lock = <img src={LockIcon} alt='Lock Icon'></img>;

// Vault Icons
const Upload = <img src={UploadIcon} alt='Upload Icon'></img>;

//ChatKGPT
const ChatBubble = <i className='far fa-comment-alt fa-fw'></i>;
const Send = <i className='far fa-paper-plane fa-fw'></i>;
const Book = <i className='far fa-book fa-fw'></i>;
const Sidebar = <i className='fa-light fa-sidebar fa-xl'></i>;

//Calendar
const CalendarX = <img src={CalendarXSvg} alt='Marked Off Calendar'></img>;
const WarningYellow = <img src={WarningYellowSvg} alt='Warning Yellow'></img>;
const CheckmarkCircleGreen = <img src={CheckmarkCircleGreenSvg} alt='Checkmark Circle Green'></img>;

// Bug Reporter Icons
const Bug = <i className='far fa-bug fa-fw'></i>;
const Camera = <i className='far fa-camera fa-fw'></i>;
const Paperclip = <i className='far fa-paperclip fa-fw'></i>;
const Lightbulb = <i className='far fa-lightbulb fa-fw'></i>;

export {
  Abacus,
  ActionAdd,
  ActionCancel,
  ActionComplete,
  ActionDelete,
  ActionDownload,
  ActionEdit,
  ActionExport,
  ActionImport,
  ActionPrint,
  ActionRefresh,
  ActionSave,
  ActionShare,
  ActionUpload,
  ActionView,
  Admin,
  AppShop,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  BirthdayCake,
  BirthdayNotif,
  Book,
  Bug,
  Building,
  Bullseye,
  Calendar,
  CalendarX,
  CalendarNotif,
  Camera,
  Car,
  CheckCircle,
  Checkmark,
  CheckmarkCircleGreen,
  ChatBubble,
  ChevronDown,
  ChevronsDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUp,
  Clipboard,
  Clock,
  Close,
  ClosedCircle,
  Comment,
  ConfirmNotif,
  Copy,
  Crosshairs,
  Delete,
  Directory,
  DocumentNotif,
  Download,
  Edit,
  Ellipsis,
  Email,
  EmptyAvatar,
  EmptyAvatarIcon,
  ErrorIcons2 as Error,
  Exit,
  Expand,
  External,
  FastForward,
  ForwardStep,
  FigmaColoured,
  FigmaNoColour,
  Filter,
  Globe,
  GradCap,
  GreenCheckmarkCircle,
  Handbook,
  Home,
  HotPepper,
  IndeterminateCheckbox,
  Info,
  Information,
  Inventory,
  ITSupport,
  Key,
  kgLogo,
  kgLogoBlack,
  kgLogoDev,
  kgLogoStage,
  Knowledge,
  Learn,
  Lightbulb,
  Link,
  List,
  LocationPin,
  Lock,
  MagicWand,
  Mail,
  Menu,
  Minus,
  MousePointer,
  Move,
  Paperclip,
  Party,
  Phone,
  Planner,
  Planner2,
  Play,
  Plus,
  Pointer,
  Polaris,
  PowerHour,
  PTOApproveNotif,
  Pulse,
  RedTrashIcon,
  Rocket,
  Salesforce,
  Sandwich,
  Save,
  Search,
  SelectedCheckbox,
  SelectedRadio,
  Send,
  Settings,
  Sidebar,
  SingleUser,
  Slack,
  SmallLock,
  Sync,
  Team,
  Telelecope,
  TimesheetSuccessNotif,
  TimesheetWarningNotif,
  UnselectedCheckbox,
  UnselectedRadio,
  Upload,
  Upload2,
  UserClock,
  Vault,
  Warning,
  WarningCircle,
  WarningYellow,
  WarningNotifOrange,
  WarningNotifRed,
};
